module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<h2>Get a professional recommendation</h2>\n<p class="reference-modal__subheader">\n    Ask a former <b>manager</b> or <b>supervisor</b> to write a recommendation.\n    This can help your profile stand out when you apply for jobs!\n</p>\n\n<div class="reference-modal__jobs">\n    <header>Which job?</header>\n    <p>\n        If the job isn\'t listed below,\n        <a href="/profile/#history" class="js-show-history">click here</a>\n        first to add it to your Work History\n    </p>\n    ';
 if (jobs.length === 0) { ;
__p += '\n        <div class="reference-modal__no-jobs">You don\'t have any jobs listed in your Work History.</div>\n    ';
 } else { ;
__p += '\n        <ul class="radio-list radio-list-left">\n            ';
 jobs.forEach(function(job, idx) { ;
__p += '\n                ';
 if (job.title) { ;
__p += '\n                    <li>\n                        <input\n                            type="radio"\n                            id="ref-job-' +
__e( idx ) +
'"\n                            name="job"\n                            value="' +
__e( idx ) +
'"\n                            ';
 if (idx === 0) { ;
__p += 'checked';
 } ;
__p += '\n                        />\n                        <label for="ref-job-' +
__e( idx ) +
'" class="fs-hide">\n                            ' +
__e( job.title ) +
',\n                            ' +
__e( job.company ) +
'\n                        </label>\n                    </li>\n                ';
 } ;
__p += '\n            ';
 }) ;
__p += '\n        </ul>\n    ';
 } ;
__p += '\n</div>\n\n';
 if (jobs.length > 0) { ;
__p += '\n    <div class="form-group">\n        <label for="manager_name">Manager/Supervisor\'s name</label>\n        <input\n            type="text"\n            class="manager-name fs-hide"\n            placeholder=""\n            autocorrect="off"\n            required\n        />\n        <span class="help-block js-name-error" style="display: none">This field is required</span>\n    </div>\n    <div class="form-group">\n        <label for="manager_number">Manager/Supervisor\'s mobile phone number\n            <span class="optional optional-manager" style="opacity: 0">\n            optional\n          </span>\n        </label>\n        <input\n            class="manager-number fs-hide"\n            type="tel"\n            placeholder="617-505-5555"\n            pattern="[0-9]*"\n            inputmode="numeric"\n            required\n        />\n        <span class="help-block js-phone-error" style="display: none">Please enter a valid phone number</span>\n    </div>\n    <div class="form-group form-group--right">\n        <button class="btn btn-primary btn-large btn-special">Request</button>\n    </div>\n';
 } ;
__p += '\n';

}
return __p
}